export default {"src":"/_next/static/media/icon-skin.ab813dad.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};